import { rest } from 'msw';

import { updateGroupsPayments } from './groupPayments';
import { getFlattenedPaymentHistory } from './paymentHistoryFlattened';
import { getSubscriptionBlockWithConcepts, listSubscriptionBlocksWithConcepts } from './subscriptionBlockConcepts';

const URL_BASE = `${process.env.REACT_APP_BASE_URL_API}/api/`;

/**
 * Mock handler for organization config endpoint
 * Returns organization configuration with feature flags
 */
const getOrganizationConfig = rest.get(`${URL_BASE}v1/organizations/:organizationUuid/config/`, (req, res, ctx) => {
  const { organizationUuid } = req.params;

  return res(
    ctx.status(200),
    ctx.json({
      data: {
        organizationUuid: organizationUuid as string,
        allowTicketEditor: false,
      },
      datetime: new Date().toISOString(),
    }),
  );
});

export const subscriptionController = [
  rest.put(`${URL_BASE}v1/organizations/:organizationUuid/`, updateGroupsPayments),
  getOrganizationConfig,
  getFlattenedPaymentHistory,
  listSubscriptionBlocksWithConcepts,
  getSubscriptionBlockWithConcepts,
];
